import { Component, ErrorHandler } from '@angular/core';

@Component({
  selector: 'app-my-error-handler',
  template: '',
  standalone: true,
})
export class MyErrorHandler implements ErrorHandler {

  /**
   * @description Manejador de errores para peticiones HTTP
   * @param {any} error
   */
  handleError(error: any): void {
    console.error('Ocurrió un error inesperado:', error);
  }
}
